import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Row, Col, FormGroup, InputGroup, Button } from "reactstrap";
import { GreyLabel,
    HighlightedInput,
    HighlightedInputGroupText,
    SmallFormFeedback,
    Spacer,
    PinkButtonContainer,
    EditIcon,
    Colors} from "../../../../utils/budget-tool-specific";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function SortableItem(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        width: '100%',
    };

    return (
        <div ref={setNodeRef} style={style}>
            <Row key={props.id}>
                <Col xs="auto" style={{display: 'flex', alignItems: 'center', paddingRight: 0}}>
                    <FAIcon
                        icon={["fas", "grip-vertical"]}
                        {...attributes}
                        {...listeners}
                        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                    />
                </Col>
                <Col lg="5">
                    <FormGroup>
                        <GreyLabel>Cost Title</GreyLabel>
                        <InputGroup>
                            <HighlightedInput placeholder="" type="text" value={props.miscCost[1].title} onChange={e => props.handleMiscellaneousChange(e.target.value, props.miscCost[1].id, "title")} />
                            <SmallFormFeedback>Required</SmallFormFeedback>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <GreyLabel>Cost</GreyLabel>
                        <InputGroup>
                            <HighlightedInputGroupText invalid={false}>
                            {props.currency}
                            </HighlightedInputGroupText>
                            <HighlightedInput placeholder="" type="number" value={props.miscCost[1].cost} onChange={e => props.handleMiscellaneousChange(parseInt(e.target.value), props.miscCost[1].id, "cost")} />
                            <SmallFormFeedback>Required</SmallFormFeedback>
                            <HighlightedInputGroupText style={{padding: "0px"}}>
                                <CheckboxButton onClick={x => props.handleMiscellaneousChange(props.miscCost[1].pp, props.miscCost[1].id, "pp")}>
                                    {props.miscCost[1].pp}
                                </CheckboxButton>
                            </HighlightedInputGroupText>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col lg="1">
                    <Spacer height="30px"></Spacer>
                    <PinkButtonContainer onClick={(x) => props.deleteMiscCost(props.miscCost[1].id)}>
                        <EditIcon icon={['fas', 'trash']} style={{height: "25px"}}/>
                    </PinkButtonContainer>
                </Col>
            </Row>
        </div>
    )
}

const FAIcon = styled(FontAwesomeIcon)`
    color: ${Colors.primaryAccent};
    display: flex;
    height: 100%;
`;

const CheckboxButton = styled(Button)`
    height: 100%;
    margin: 0px;
    border: none;
    border-radius: 0px;
    background-color: ${Colors.primaryAccent};
    color: black;
    &: hover {
        background-color: ${Colors.primaryDark};
        color: white;
    }
    &: focus{
        background-color: ${Colors.primaryAccent};
        color: black;
    }
    &: selected{
        background-color: ${Colors.primaryDark};
        color: black;
    }
`
